"use strict";

exports.__esModule = true;
var _ErrorBoundary = require("./ErrorBoundary");
Object.keys(_ErrorBoundary).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorBoundary[key]) return;
  exports[key] = _ErrorBoundary[key];
});